import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { createHttpParams } from '~/infrastructure/http/params';
import { augmentPaging } from '~/infrastructure/paging';
import { FileSummary } from '~/models/modules/file';
import { ApiServiceBase, API_NAMES } from '~/services/api';

@Injectable({ providedIn: 'root' })
export class FilesService extends ApiServiceBase {
       private filesClosed: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.stocks);
  }

  getFile(id: number) {
    return this.http.get<FileSummary>(this._url(`/${id}`));
  }

   getPictureFilesSummary() {
    return this.http.get<FileSummary[]>(this._url(`/compogrid-filepicture`));
  }


  getPictures(paramsObj?: any, model?: any) {
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    return this.http
      .post<FileSummary[]>(this._url(`/grid-data-picture`), model, {
        params,
        observe: 'response',
      })
      .pipe(map(augmentPaging));
  }

  getDocuments(paramsObj?: any, model?: any){
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    return this.http
      .post<FileSummary[]>(this._url(`/grid-data-document`), model, {
        params,
        observe: 'response',
      })
      .pipe(map(augmentPaging));
  }
  getDocumentsByIds(paramsObj?: any, model?: any, ByIds?: any){
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    paramsObj.ByIds = ByIds;
    let params = createHttpParams(paramsObj);

    return this.http
      .post<FileSummary[]>(this._url(`/grid-data-document-by-ids`), model, {
        params,
        observe: 'response',
      })
      .pipe(map(augmentPaging));
  }
  getVideos(paramsObj?: any, model?: any){
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    return this.http
      .post<FileSummary[]>(this._url(`/grid-data-video`), model, {
        params,
        observe: 'response',
      })
      .pipe(map(augmentPaging));
  }
  getAllDocuments(accountIds: number[],paramsObj?: any, model?: any){
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);
    model['accountIds'] = accountIds;
    return this.http
      .post<FileSummary[]>(this._url(`/grid-data-document`), model, {
        params,
        observe: 'response',
      })
      .pipe(map(augmentPaging));
  }
  getAccountsPictures(accountIds: number[], paramsObj?: any, model?: any) {
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    model['accountIds'] = accountIds;

    return this.http
      .post<FileSummary[]>(this._url(`/ImagesByaccounts`), model, {
        params,
        observe: 'response',
      })
      .pipe(map(augmentPaging));
  }


  createFileRange(model: any) {
    return this.client.post<number[]>(this._url(`/create-range`), model);
  }

  createFile(model: any) {
    return this.client.post<string>(this._url(), model);
  }

  createFileCopy(model: any) {
    return this.client.post<number[]>(this._url(`/create-file-copy`), model);
  }

  updateFile(id: number, model: any) {
    return this.client.put(this._url(`/${id}`), model);
  }

  deleteFile(id: number) {
    return this.client.delete(this._url(`/${id}`));
  }
  downloadFilebyPath(url: string): Observable<Blob> {
    return this.http.get(url, {
      responseType: 'blob'
    })
  }
  // downloadFileById(id: number): Observable<Blob> {
  //   this.http.get<FileSummary>(this._url(`/${id}`)).subscribe((file:FileSummary) => {
  //     return this.http.get(url, {
  //       responseType: 'blob'
  //     })
  //   })
  // }
  isRelated(id: number) {
    return this.client.post<boolean>(this._url(`/is-related/${id}`), null);
  }
  deactivateFiles(obj: any) {
    return this.client.put(this._url(`/deactivate`), obj);
  }
  deactivateFileBatch(obj: any) {
    return this.client.put(this._url(`/batchDeactivate`), obj);
  }
  reactivateFiles(obj: any) {
    return this.client.put(this._url(`/reactivate`), obj);
  }

  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/files${v}`);
  }

    filesFormClosed(newValue: any) {
        this.filesClosed.next(newValue);
    }

}
